import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Roles from "./pages/Roles";
import Cameras from "./pages/Cameras";
import CameraMonitoring from "./pages/CameraMonitoring";
import OptimizedCameraMonitoring from "./pages/OptimizedCameraMonitoring";
import PerformanceComparison from "./components/PerformanceComparison";
import RTSPUrlGeneratorPage from "./pages/RTSPUrlGenerator";
import Profile from "./pages/Profile";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Support from "./pages/Support";
import ProtectedRoute from "./components/ProtectedRoute";
import SuperAdminOnlyRoute from "./components/SuperAdminOnlyRoute";
import FirstLoginWrapper from "./components/FirstLoginWrapper";

function App() {
  const { user, loading } = useAuth();

  console.log('App render - user:', user, 'loading:', loading);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Verifying authentication...</p>
          <p className="text-sm text-gray-500 mt-2">Please wait</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route
        path="/login"
        element={user ? <Navigate to="/camera-monitoring" /> : <Login />}
      />
      <Route
        path="/signup"
        element={user ? <Navigate to="/camera-monitoring" /> : <Signup />}
      />
      <Route
        path="/forgot-password"
        element={user ? <Navigate to="/camera-monitoring" /> : <ForgotPassword />}
      />
      <Route
        path="/reset-password"
        element={user ? <Navigate to="/camera-monitoring" /> : <ResetPassword />}
      />
      <Route
        path="/privacy-policy"
        element={<PrivacyPolicy />}
      />
      <Route
        path="/support"
        element={<Support />}
      />

      {/* Protected routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <FirstLoginWrapper>
              <Layout />
            </FirstLoginWrapper>
          </ProtectedRoute>
        }
      >
        <Route index element={<Navigate to="/camera-monitoring" />} />
        <Route path="performance-comparison" element={<PerformanceComparison />} />
        <Route path="camera-monitoring" element={<CameraMonitoring />} />
        <Route path="camera-monitoring-optimized" element={<OptimizedCameraMonitoring />} />
        <Route path="dashboard" element={
          <SuperAdminOnlyRoute>
            <Dashboard />
          </SuperAdminOnlyRoute>
        } />
        <Route path="users" element={<Users />} />
        <Route path="roles" element={<Roles />} />
        {/* <Route path="cameras" element={<Cameras />} />  */}
        
        <Route path="camera-playback" element={<RTSPUrlGeneratorPage />} />
        <Route path="profile" element={<Profile />} />
      </Route>

      {/* Debug route */}
      <Route
        path="/debug"
        element={
          <div className="p-8">
            <h1 className="text-2xl font-bold mb-4">Debug Info</h1>
            <pre className="bg-gray-100 p-4 rounded">
              {JSON.stringify({ user, loading }, null, 2)}
            </pre>
          </div>
        }
      />

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/camera-monitoring" />} />
    </Routes>
  );
}

export default App;
